import React from "react";
import "./Product_Specification_card.css";
import { Table } from "react-bootstrap";

function Product_Specification_card({order}) {
  const productSpecifications = [
    { label: "Card Type", value: "Translucent Card - Rounded corner" },
    { label: "Orientation", value: "Landscape" },
    { label: "Materials", value: "Translucent Card (185 micron Thick Card)" },
    { label: "Shape and Size", value: "Rectangle (3.5 x 2 in)" },
    { label: "Orientation", value: "Portrait" },
  ];

  return (
    <>
      <section className="Product_Specification_card">
        <div className="My_order_card">
          <div className="row">
            {/* Product Details Section */}
            <div className="col-md-12 col-sm-12 ">
              <div className="card_inner_content">
                <div className="heading_status_holder">
                  <div className="heading_holder">
                    <h3>Product Specification</h3>
                  </div>
                </div>
              </div>

              <div className="card_inner_content card_inner_content_two">
                <div className="main_table_holder">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="heading_table_holder">
                        <div className="info_table_holder">
                          <Table responsive>
                            <tbody>
                              {order?.Product_Combination?.round_corner && (
                                <tr>
                                  <td>Card Type</td>
                                  <td> Rounded corner</td>
                                </tr>
                              )}
                              {order?.Product_Combination?.Orientation && (
                                <tr>
                                  <td>Orientation</td>
                                  <td>
                                    {order?.Product_Combination?.Orientation.name}
                                  </td>
                                </tr>
                              )}
                              {order?.Product_Combination?.Material && (
                                <tr>
                                  <td>Material</td>
                                  <td>
                                    {order?.Product_Combination?.Material.name}
                                  </td>
                                </tr>
                              )}
                              {order?.Product_Combination?.Size && (
                                <tr>
                                  <td>Size</td>
                                  <td>{order?.Product_Combination?.Size.name}</td>
                                </tr>
                              )}
                              {order?.Product_Combination?.Lamination && (
                                <tr>
                                  <td>Lamination</td>
                                  <td>
                                    {order?.Product_Combination?.Lamination.name}
                                  </td>
                                </tr>
                              )}
                              {order?.Product_Combination?.Envelope && (
                                <tr>
                                  <td>Envelope</td>
                                  <td>
                                    {order?.Product_Combination?.Envelope.name}
                                  </td>
                                </tr>
                              )}
                              {order?.Product_Combination?.PrintingLocation && (
                                <tr>
                                  <td>Print</td>
                                  <td>
                                    {
                                      order?.Product_Combination?.PrintingLocation
                                        .name
                                    }
                                  </td>
                                </tr>
                              )}
                              {order?.Product?.Shape && (
                                <tr>
                                  <td>Shape</td>
                                  <td>{order?.Product?.Shape.name}</td>
                                </tr>
                              )}
                            </tbody>
                          </Table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Product_Specification_card;
